
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M512 949.138c238.72 0 437.138-197.997 437.138-437.138 0-238.72-198.857-437.138-437.577-437.138C272.44 74.862 74.88 273.28 74.88 512c0 239.14 197.998 437.138 437.138 437.138zm0-72.85c-202.295 0-363.886-162.011-363.886-364.288 0-201.874 161.152-364.288 363.447-364.288 201.856 0 364.27 162.432 364.709 364.288.42 202.295-162.432 364.288-364.288 364.288z","fill":"#666"}})])
          )
        }
      }
    